import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedAdminRoute from "@/components/ProtectedAdminRoute";
import CookieBanner from "@/components/CookieBanner";

import PublicLayout from "@/components/public/PublicLayout";
import Home from "@/pages/public/Home";
import DealDetail from "@/pages/public/DealDetail";
import SubmitDeal from "@/pages/public/SubmitDeal";
import Profile from "@/pages/public/Profile";
import Impressum from "@/pages/public/Impressum";
import Datenschutz from "@/pages/public/Datenschutz";
import AGB from "@/pages/public/AGB";
import Login from "@/pages/auth/Login";
import Register from "@/pages/auth/Register";

import Layout from "@/components/Layout";
import Overview from "@/pages/Overview";
import Deals from "@/pages/Deals";
import ContentGenerator from "@/pages/ContentGenerator";
import NicheFinder from "@/pages/NicheFinder";
import Submissions from "@/pages/admin/Submissions";
import Analytics from "@/pages/admin/Analytics";

function App() {
  useEffect(() => {
    document.title = "dealzauber.de – Die magischsten Deals";
  }, []);

  return (
    <div className="App min-h-screen">
      <BrowserRouter>
        <AuthProvider>
          <CookieBanner />
          <Routes>
            {/* Public site */}
            <Route element={<PublicLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/kategorie/:slug" element={<Home />} />
              <Route path="/suche" element={<Home />} />
              <Route path="/deal/:id" element={<DealDetail />} />
              <Route path="/deal-einreichen" element={<SubmitDeal />} />
              <Route path="/profil" element={<Profile />} />
              <Route path="/impressum" element={<Impressum />} />
              <Route path="/datenschutz" element={<Datenschutz />} />
              <Route path="/agb" element={<AGB />} />
            </Route>

            {/* Auth */}
            <Route path="/login" element={<Login />} />
            <Route path="/registrieren" element={<Register />} />

            {/* Admin cockpit (protected) */}
            <Route
              path="/admin"
              element={
                <ProtectedAdminRoute>
                  <Layout />
                </ProtectedAdminRoute>
              }
            >
              <Route index element={<Overview />} />
              <Route path="deals" element={<Deals />} />
              <Route path="content" element={<ContentGenerator />} />
              <Route path="niches" element={<NicheFinder />} />
              <Route path="submissions" element={<Submissions />} />
              <Route path="analytics" element={<Analytics />} />
            </Route>

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
